import Cookies from 'js-cookie';
import * as types from '../mutation-types';

// state
export const state = {
    history: Cookies.getJSON('nav_history') ? Cookies.getJSON('nav_history') : [],
};

// mutations
export const mutations = {
    [types.HISTORY_ADD](state, entry) {
        if(state.history.length >= 5) {
            state.history.pop()
        }

        state.history.push({ meta: entry.meta, name: entry.name, params: entry.params });

        Cookies.set('nav_history', JSON.stringify(state.history), {expires: 1});
    },

    [types.HISTORY_CLEAR](state) {
        state.history = [];

        Cookies.set('nav_history', JSON.stringify(state.history), {expires: 1});
    },
};

// actions
export const actions = {
    addHistory({commit}, payload) {
        commit(types.HISTORY_ADD, payload);
    },

    clearHistory({commit}) {
        commit(types.HISTORY_CLEAR);
    },
};

// getters
export const getters = {
    history: (state) => state.history ? _.drop(state.history, state.history.length - 10) : [],
};
